// modules are defined as an array
// [ module function, map of requires ]
//
// map of requires is short require name -> numeric require
//
// anything defined in a previous bundle is accessed via the
// orig method which is the require for previous bundles

(function (modules, entry, mainEntry, parcelRequireName, globalName) {
  /* eslint-disable no-undef */
  var globalObject =
    typeof globalThis !== 'undefined'
      ? globalThis
      : typeof self !== 'undefined'
      ? self
      : typeof window !== 'undefined'
      ? window
      : typeof global !== 'undefined'
      ? global
      : {};
  /* eslint-enable no-undef */

  // Save the require from previous bundle to this closure if any
  var previousRequire =
    typeof globalObject[parcelRequireName] === 'function' &&
    globalObject[parcelRequireName];

  var cache = previousRequire.cache || {};
  // Do not use `require` to prevent Webpack from trying to bundle this call
  var nodeRequire =
    typeof module !== 'undefined' &&
    typeof module.require === 'function' &&
    module.require.bind(module);

  function newRequire(name, jumped) {
    if (!cache[name]) {
      if (!modules[name]) {
        // if we cannot find the module within our internal map or
        // cache jump to the current global require ie. the last bundle
        // that was added to the page.
        var currentRequire =
          typeof globalObject[parcelRequireName] === 'function' &&
          globalObject[parcelRequireName];
        if (!jumped && currentRequire) {
          return currentRequire(name, true);
        }

        // If there are other bundles on this page the require from the
        // previous one is saved to 'previousRequire'. Repeat this as
        // many times as there are bundles until the module is found or
        // we exhaust the require chain.
        if (previousRequire) {
          return previousRequire(name, true);
        }

        // Try the node require function if it exists.
        if (nodeRequire && typeof name === 'string') {
          return nodeRequire(name);
        }

        var err = new Error("Cannot find module '" + name + "'");
        err.code = 'MODULE_NOT_FOUND';
        throw err;
      }

      localRequire.resolve = resolve;
      localRequire.cache = {};

      var module = (cache[name] = new newRequire.Module(name));

      modules[name][0].call(
        module.exports,
        localRequire,
        module,
        module.exports,
        this
      );
    }

    return cache[name].exports;

    function localRequire(x) {
      var res = localRequire.resolve(x);
      return res === false ? {} : newRequire(res);
    }

    function resolve(x) {
      var id = modules[name][1][x];
      return id != null ? id : x;
    }
  }

  function Module(moduleName) {
    this.id = moduleName;
    this.bundle = newRequire;
    this.exports = {};
  }

  newRequire.isParcelRequire = true;
  newRequire.Module = Module;
  newRequire.modules = modules;
  newRequire.cache = cache;
  newRequire.parent = previousRequire;
  newRequire.register = function (id, exports) {
    modules[id] = [
      function (require, module) {
        module.exports = exports;
      },
      {},
    ];
  };

  Object.defineProperty(newRequire, 'root', {
    get: function () {
      return globalObject[parcelRequireName];
    },
  });

  globalObject[parcelRequireName] = newRequire;

  for (var i = 0; i < entry.length; i++) {
    newRequire(entry[i]);
  }

  if (mainEntry) {
    // Expose entry point to Node, AMD or browser globals
    // Based on https://github.com/ForbesLindesay/umd/blob/master/template.js
    var mainExports = newRequire(mainEntry);

    // CommonJS
    if (typeof exports === 'object' && typeof module !== 'undefined') {
      module.exports = mainExports;

      // RequireJS
    } else if (typeof define === 'function' && define.amd) {
      define(function () {
        return mainExports;
      });

      // <script>
    } else if (globalName) {
      this[globalName] = mainExports;
    }
  }
})({"eBWfs":[function(require,module,exports) {
//basic
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "prof", ()=>prof);
parcelHelpers.export(exports, "aboutme", ()=>aboutme);
parcelHelpers.export(exports, "Hover", ()=>Hover);
parcelHelpers.export(exports, "NHover", ()=>NHover);
const cont = document.getElementsByClassName("InfoContainer")[0];
const contovr = document.getElementsByClassName("ContainerOverlay")[0];
const prof = document.getElementById("ProfileImage");
const socT = document.getElementById("socialTwitter");
const socD = document.getElementById("socialDiscord");
const socR = document.getElementById("socialReddit");
const socL = document.getElementById("socialLinkedin");
const BGText = document.getElementById("TextClass");
const hoverClass = document.getElementById("HoverClass");
//aboutme
const abouttext = document.getElementsByClassName("AboutMeText")[0];
const aboutme = document.getElementsByClassName("AboutMe")[0];
const aboutBod = document.getElementsByClassName("AboutBody")[0];
const aboutbody = document.getElementById("AboutImage");
//feedback
const contain = document.getElementsByClassName("ContainerDropdown")[0];
const dgtitle = document.getElementById("DGTitle");
//Gallery
const gallimgs = document.getElementsByClassName("image");
document.addEventListener("contextmenu", (event)=>{
    event.preventDefault();
});
let social1X, social1Y, social2X, social2Y;
let hovered = false;
let animating = false;
const hoverAnimDur = 400; // milliseconds
const NormalTime = {
    duration: 300,
    iterations: 1,
    fill: "forwards",
    direction: "normal",
    easing: "ease"
};
const NormalTimeSlower = {
    duration: 400,
    iterations: 1,
    fill: "forwards",
    direction: "normal",
    easing: "ease"
};
const ReverseTime = {
    duration: 250,
    iterations: 1,
    fill: "forwards",
    direction: "reverse",
    easing: "ease"
};
const Scaleintime = {
    duration: 400,
    iterations: 1,
    fill: "forwards",
    direction: "normal",
    easing: "ease"
};
let twitter, instagram, reddit, linkedin;
function resize() {
    social1X = 170;
    social1Y = 190;
    social2X = 235;
    social2Y = 40;
    twitter = [
        {
            transform: "translate(0px, 0px) scale(.5)"
        },
        {
            transform: `translate(${-social1X}px,${social1Y}px) scale(.9)`
        }
    ];
    instagram = [
        {
            transform: "translate(0px, 0px) scale(.5)"
        },
        {
            transform: `translate(${social1X}px,${social1Y}px) scale(.9)`
        }
    ];
    reddit = [
        {
            transform: "translate(0px, 0px) scale(.5)"
        },
        {
            transform: `translate(${-social2X}px, ${social2Y}px) scale(.8)`
        }
    ];
    linkedin = [
        {
            transform: "translate(0px, 0px) scale(.5)"
        },
        {
            transform: `translate(${social2X}px, ${social2Y}px) scale(.8)`
        }
    ];
    NHover();
}
resize();
window.addEventListener("resize", resize);
document.getElementById("HoverClass").addEventListener("mouseenter", ()=>Hover(true));
document.getElementById("HoverClass").addEventListener("mouseleave", ()=>NHover(true));
function Hover(real) {
    // console.log(`${real ? "Real" : "Fake"} Hovered`);
    hovered = true;
    //here we have this check so that we don't restart the animation
    if (animating) return;
    animating = true;
    //the animation data itself
    socT.animate(twitter, NormalTime);
    socD.animate(instagram, NormalTime);
    socR.animate(reddit, NormalTimeSlower);
    socL.animate(linkedin, NormalTimeSlower).onfinish = ()=>{
        animating = false;
        if (!hovered) NHover(false);
    };
// console.log(socL);
}
function NHover(real) {
    // console.log(`${real ? "Real" : "Fake"} Stopped Hovering`);
    hovered = false;
    if (animating) return;
    animating = true;
    socT.animate(twitter, ReverseTime);
    socD.animate(instagram, ReverseTime);
    socR.animate(reddit, ReverseTime);
    socL.animate(linkedin, ReverseTime).onfinish = ()=>{
        animating = false;
        if (hovered) Hover(false);
    };
}
const infButton = document.querySelector("#infoToggle");
const infBubble = document.querySelector(".infoBubble");
infButton.addEventListener("click", showMessage);
// infButton.addEventListener('mouseleave', showMessage);
let isVisible = false;
function showMessage() {
    if (isVisible == false) {
        isVisible = true;
        infBubble.classList.remove("classClose");
    } else {
        isVisible = false;
        infBubble.classList.add("classClose");
    }
}
const inViewport = (entries, observer)=>{
    entries.forEach((entry)=>{
        entry.target.classList.toggle("is-inViewport", entry.isIntersecting);
    });
};
const Obs = new IntersectionObserver(inViewport);
const obsOptions = {};
document.querySelectorAll(".image").forEach((el)=>{
    // console.log(el);
    Obs.observe(el, obsOptions);
});

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"k3151":[function(require,module,exports) {
exports.interopDefault = function(a) {
    return a && a.__esModule ? a : {
        default: a
    };
};
exports.defineInteropFlag = function(a) {
    Object.defineProperty(a, "__esModule", {
        value: true
    });
};
exports.exportAll = function(source, dest) {
    Object.keys(source).forEach(function(key) {
        if (key === "default" || key === "__esModule" || Object.prototype.hasOwnProperty.call(dest, key)) return;
        Object.defineProperty(dest, key, {
            enumerable: true,
            get: function() {
                return source[key];
            }
        });
    });
    return dest;
};
exports.export = function(dest, destName, get) {
    Object.defineProperty(dest, destName, {
        enumerable: true,
        get: get
    });
};

},{}]},["eBWfs"], "eBWfs", "parcelRequire2041")

//# sourceMappingURL=index.61dc437d.js.map
